type Tier = 'scout' | 'investor' | 'syndicate'

export interface FeatureLimits {
  maxProperties: number | null
  hasDeveloperAccess: boolean
  hasPrelaunchSignals: boolean
  hasMemberDiscount: boolean
  hasBulkDeals: boolean
  hasPortfolioManagement: boolean
  hasAirportShuttle: boolean
  hasAllocationPriority: boolean
  hasVIPSupport: boolean
  hasInsiderPerk: boolean
  hasStrategyCall: boolean
  hasSyndicateGroupBuys: boolean
  hasDeveloperVault: 'none' | 'limited' | 'full'
}

export const TIER_FEATURES: Record<Tier, FeatureLimits> = {
  scout: {
    maxProperties: 0,
    hasDeveloperAccess: false,
    hasPrelaunchSignals: false,
    hasMemberDiscount: false,
    hasBulkDeals: false,
    hasPortfolioManagement: false,
    hasAirportShuttle: false,
    hasAllocationPriority: false,
    hasVIPSupport: false,
    hasInsiderPerk: true,
    hasStrategyCall: true,
    hasSyndicateGroupBuys: false,
    hasDeveloperVault: 'none',
  },
  investor: {
    maxProperties: 3,
    hasDeveloperAccess: true,
    hasPrelaunchSignals: true,
    hasMemberDiscount: true,
    hasBulkDeals: true,
    hasPortfolioManagement: true,
    hasAirportShuttle: false,
    hasAllocationPriority: false,
    hasVIPSupport: false,
    hasInsiderPerk: true,
    hasStrategyCall: true,
    hasSyndicateGroupBuys: true,
    hasDeveloperVault: 'limited',
  },
  syndicate: {
    maxProperties: null,
    hasDeveloperAccess: true,
    hasPrelaunchSignals: true,
    hasMemberDiscount: true,
    hasBulkDeals: true,
    hasPortfolioManagement: true,
    hasAirportShuttle: true,
    hasAllocationPriority: true,
    hasVIPSupport: true,
    hasInsiderPerk: true,
    hasStrategyCall: true,
    hasSyndicateGroupBuys: true,
    hasDeveloperVault: 'full',
  },
}

export const TIERS: Tier[] = ['scout', 'investor', 'syndicate']

export const isValidTier = (tier: unknown): tier is Tier =>
  typeof tier === 'string' && TIERS.includes(tier as Tier)

export type { Tier }
